export const contextConstant = {
  GET_ME: "GET_ME",
  GET_RENTS_STATUS: "GET_RENTS_STATUS",
  GET_TIMES_LEFT: "GET_TIMES_LEFT",
  SET_SHOW_LOGIN_MODAL: "SET_SHOW_LOGIN_MODAL",
};
